export default "__VITE_ASSET__DJn35lus__"